export default "__VITE_ASSET__Dfm4C4jv__"